module.exports = __webpack_public_path__ + "img/1728708687.e08a861f.jpg";